const generateData = (multiplier) => {
    const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const data = {};
  
    days.forEach((day) => {
      data[day] = Array.from({ length: 24 }, () => 
        Math.floor(Math.random() * multiplier)
      );
    });
    
    return data;
  };
  export const dashboardHeatmapData = {
    status: true,
    title: "Overall Network Activity",
    data: generateData(100),
  };

  export const fleetHeatmapData = {
    status: true,
    title: "Fleet Distribution - Proms Complex",
    data: generateData(20),
  };

  export const driverHeatmapData = {
    status: true,
    title: "Driver Activity - Rahul Nalawade",
    data: generateData(5), 
  };